import { FunctionComponent } from "react";
import { cx } from "class-variance-authority";

export interface VerticalDividerProps {
  className?: string;
}

/**
 *
 */
export const VerticalDivider: FunctionComponent<VerticalDividerProps> = ({
  className,
  ...props
}) => {
  const css = cx(className, "w-[1px] border-0 margin-0");
  return <hr className={css}></hr>;
};
